"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateMediaTypeObject = exports.translateHeaderObject = void 0;
const json_1 = require("@stoplight/json");
const types_1 = require("@stoplight/types");
const pickBy = require("lodash.pickby");
const context_1 = require("../../context");
const guards_1 = require("../../guards");
const examples_1 = require("../../oas/transformers/examples");
const schema_1 = require("../../oas/transformers/schema");
const utils_1 = require("../../utils");
const guards_2 = require("../guards");
const examples_2 = require("./examples");
const ACCEPTABLE_STYLES = [
    types_1.HttpParamStyles.Form,
    types_1.HttpParamStyles.SpaceDelimited,
    types_1.HttpParamStyles.PipeDelimited,
    types_1.HttpParamStyles.DeepObject,
];
function hasAcceptableStyle(encodingPropertyObject) {
    return typeof encodingPropertyObject.style === 'string' && ACCEPTABLE_STYLES.includes(encodingPropertyObject.style);
}
const translateEncodingPropertyObject = (0, context_1.withContext)(function ([property, encodingPropertyObject]) {
    if (!(0, json_1.isPlainObject)(encodingPropertyObject))
        return;
    if (!hasAcceptableStyle(encodingPropertyObject))
        return;
    return {
        property,
        style: encodingPropertyObject.style,
        headers: (0, utils_1.entries)(encodingPropertyObject.headers).map(exports.translateHeaderObject, this).filter(guards_1.isNonNullable),
        ...pickBy({
            allowReserved: encodingPropertyObject.allowReserved,
            explode: encodingPropertyObject.explode,
        }, guards_1.isBoolean),
        ...pickBy({
            mediaType: encodingPropertyObject.contentType,
        }, guards_1.isString),
    };
});
exports.translateHeaderObject = (0, context_1.withContext)(function ([name, unresolvedHeaderObject]) {
    const headerObject = this.maybeResolveLocalRef(unresolvedHeaderObject);
    if (!(0, json_1.isPlainObject)(headerObject))
        return;
    const id = this.generateId(`http_header-${this.parentId}-${name}`);
    if (!(0, guards_2.isHeaderObject)(headerObject)) {
        return {
            id,
            encodings: [],
            examples: [],
            name,
            style: types_1.HttpParamStyles.Simple,
        };
    }
    const { content: contentObject } = headerObject;
    const contentValue = (0, json_1.isPlainObject)(contentObject) ? Object.values(contentObject)[0] : null;
    const baseContent = {
        id,
        name,
        style: types_1.HttpParamStyles.Simple,
        ...pickBy({
            schema: (0, json_1.isPlainObject)(headerObject.schema) ? schema_1.translateSchemaObject.call(this, headerObject.schema) : null,
            content: headerObject.content,
        }, guards_1.isNonNullable),
        ...pickBy({
            description: headerObject.description,
        }, guards_1.isString),
        ...pickBy({
            allowEmptyValue: headerObject.allowEmptyValue,
            allowReserved: headerObject.allowReserved,
            explode: headerObject.explode,
            required: headerObject.required,
            deprecated: headerObject.deprecated,
        }, guards_1.isBoolean),
    };
    const examples = [];
    const encodings = [];
    if ((0, json_1.isPlainObject)(contentValue)) {
        examples.push(...(0, utils_1.entries)(contentValue.examples).map(examples_2.translateToExample, this).filter(guards_1.isNonNullable));
        if ((0, json_1.isPlainObject)(contentValue.encoding)) {
            encodings.push(...Object.values(contentValue.encoding));
        }
        if ('example' in contentValue) {
            examples.push(examples_1.translateToDefaultExample.call(this, '__default_content', contentValue.example));
        }
    }
    examples.push(...(0, utils_1.entries)(headerObject.examples).map(examples_2.translateToExample, this).filter(guards_1.isNonNullable));
    if ('example' in headerObject) {
        examples.push(examples_1.translateToDefaultExample.call(this, '__default', headerObject.example));
    }
    return {
        ...baseContent,
        encodings,
        examples,
    };
});
const translateSchemaMediaTypeObject = (0, context_1.withContext)(function (schema) {
    if (!(0, json_1.isPlainObject)(schema))
        return;
    return schema_1.translateSchemaObject.call(this, schema);
});
exports.translateMediaTypeObject = (0, context_1.withContext)(function ([mediaType, mediaObject]) {
    var _a;
    if (!(0, json_1.isPlainObject)(mediaObject))
        return;
    const id = this.generateId(`http_media-${this.parentId}-${mediaType}`);
    const { schema, encoding, examples } = mediaObject;
    const jsonSchema = translateSchemaMediaTypeObject.call(this, schema);
    const defaultExample = 'example' in mediaObject ? mediaObject.example : (_a = jsonSchema === null || jsonSchema === void 0 ? void 0 : jsonSchema.examples) === null || _a === void 0 ? void 0 : _a[0];
    return {
        id,
        mediaType,
        examples: [
            defaultExample !== undefined ? examples_1.translateToDefaultExample.call(this, 'default', defaultExample) : undefined,
            ...(0, utils_1.entries)(examples).map(examples_2.translateToExample, this),
        ].filter(guards_1.isNonNullable),
        encodings: (0, utils_1.entries)(encoding).map(translateEncodingPropertyObject, this).filter(guards_1.isNonNullable),
        ...pickBy({
            schema: jsonSchema,
        }, guards_1.isNonNullable),
    };
});
//# sourceMappingURL=content.js.map